export const TO_QUERY_PARAM = 'to';
export const FROM_QUERY_PARAM = 'from';
export const CONFIG_QUERY_PARAM = 'config';
export const UNSAVED_SEARCH_QUERY_PARAM = 'feed_hash';
export const TIME_UNIT_QUERY_PARAM = 'timeUnit';
export const WIDGET_ID_QUERY_PARAM = 'widgetId';
export const CONTEXT_IDS_QUERY_PARAM = 'contextIds';
export const CONTEXT_IDS_QUERY_PARAM_SPLITTER = '-';
export const SHARED_LINK_CODE = 'shared_link_code';
export const SENTIMENT_QUERY_PARAM = 'sentiments';
export const NETWORK_QUERY_PARAM = 'networks';
export const CC_SEARCH_QUERY_PARAM = 'ccSearch';
